// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"1f3db09d","84":"9ffc2bdb","95":"73580572","563":"e6585dc6","719":"d6a5bc8e","757":"c44a756c","779":"28d5d954","829":"c8fb1f63"}[chunkId] + ".chunk.js";
};